import { PageHeader } from '@repo/ui/components/page-header'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from '@/lib/i18n'
import { SearchForm } from './-components/search-form'
import { SearchResults } from './-components/search-results'

export const Route = createFileRoute('/(private)/assistenza/')({
	component: SupportPage
})

/** One field to find a student by email, protocol or tax code. */
function SupportPage() {
	const { t } = useTranslation()
	return (
		<main className='flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto p-4 md:p-6'>
			<PageHeader title={t('admin-support:page_title')} />
			<SearchForm />
			<p className='max-w-prose text-muted-foreground text-sm'>
				{t('admin-support:search.hint')}
			</p>
			<SearchResults />
		</main>
	)
}
